import { useEffect, useRef } from 'react';
import { useCancelJob } from '../dispatchPlus/Dispatch/Jobs/Job/CancelJob/useCancelJob.hook';

export const CancelJob = ({ isOpen, ...selectedDayJobToRemove }) => {
    const showModalRef = useRef(false);

    const handleRemoveDayJob = useCancelJob(selectedDayJobToRemove);

    useEffect(() => {
        if (isOpen && isOpen !== showModalRef.current) {
            handleRemoveDayJob();
        }

        showModalRef.current = isOpen;
    }, [isOpen, handleRemoveDayJob]);

    return null;
};